<template>
  <div>
    <AthleteSectionHeading>Athletic</AthleteSectionHeading>
    <div v-if="hasAnyContent">
      <Affiliations ref="Affiliations" :show-links="showLinks" />
      <AthleteStats />
      <div v-if="isLoggedOut" class="flex mb-5">
        <LoginBoxCTA class="w-full md:w-auto md:ml-auto" />
      </div>
      <AthletePressLinks />
    </div>
    <EmptyState v-else ref="EmptyState" />
  </div>
</template>

<script>
import AthleteSectionHeading from "../../AthleteSectionHeading.vue";
import { mapState, mapGetters } from "vuex";
import Affiliations from "../../Affiliations/List.vue";
import AthleteStats from "./AthleteStats.vue";
import AthletePressLinks from "../../AthletePressLinks.vue";
import LoginBoxCTA from "../../OTG/LoginBoxCTA.vue";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import EmptyState from "./EmptyState/AthleteAthleticEmptyState.vue";

const has = (obj, path) => !isEmpty(get(obj, path));

export default {
  components: {
    EmptyState,
    AthleteSectionHeading,
    Affiliations,
    AthleteStats,
    AthletePressLinks,
    LoginBoxCTA,
  },

  props: {
    showLinks: { required: false, default: true, type: Boolean },
  },

  computed: {
    hasAnyContent() {
      // TODO: Do this better
      return (
        has(this.user, "pressLinks") ||
        has(this.user, "teamAffiliations") ||
        has(this.user, "nonIntegratedAffiliations") ||
        has(this.user, "height") ||
        has(this.user, "weight") ||
        has(this.user, "positions") ||
        has(this.user, "athleticStats")
      );
    },

    ...mapState({
      user: state => state.athleteProfile.user,
    }),

    ...mapGetters({
      teams: "athleteProfile/allTeams",
      isLoggedOut: "userData/isLoggedOut",
    }),
  },
};
</script>

<style scoped>
</style>